import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const GA4_ID = 'G-PK73KNBBXG';
const CLARITY_ID = 'XXXXXXXXXX';     // Replace with your Microsoft Clarity Project ID

function loadGA4() {
  if (document.getElementById('ga4-script')) return;
  const script = document.createElement('script');
  script.id = 'ga4-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA4_ID, {
      anonymize_ip: true,
      send_page_view: false,  // We fire page_view manually on SPA route changes
    });
  };
}

function loadClarity() {
  if (CLARITY_ID === 'XXXXXXXXXX') return;  // Skip if no real Clarity ID configured
  if (document.getElementById('clarity-script')) return;
  const script = document.createElement('script');
  script.id = 'clarity-script';
  script.type = 'text/javascript';
  script.textContent = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y)})(window,document,"clarity","script","${CLARITY_ID}");`;
  document.head.appendChild(script);
}

const CONSENT_KEY = 'mediamars_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === 'accepted') {
      loadGA4();
      loadClarity();
    } else if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
    loadGA4();
    loadClarity();
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
      <div className="cookie-inner">
        <div className="cookie-text">
          <p className="cookie-heading">We value your privacy</p>
          <p>
            We use <strong>essential cookies</strong> to make our site work (e.g. remembering your preferences). 
            We'd also like to use <strong>analytics cookies</strong> (Google Analytics) to understand how you use our site so we can improve it. 
            Analytics cookies are only set if you accept. <a href="/privacy">Privacy Policy</a>
          </p>
        </div>
        <div className="cookie-actions">
          <button className="cookie-btn accept" onClick={handleAccept}>Accept All</button>
          <button className="cookie-btn decline" onClick={handleDecline}>Essential Only</button>
        </div>
      </div>
    </div>
  );
}
